import { h } from 'preact';

const MAP_TYPES = [
  { type: 'categorical', label: 'By candidate' },
  { type: 'breakdown', label: 'Breakdown' },
];

// Toggle between the county map ("By candidate") and the pie cartogram
const MapTypeButtons = ({ active, onSelect }) => (
  <div class="map-btn-group">
    {MAP_TYPES.map(({ type, label }) => (
      <button
        className={
          active === type ? 'map-button map-button--active' : 'map-button'
        }
        onClick={() => onSelect(type)}
      >
        {label}
      </button>
    ))}
  </div>
);

export default MapTypeButtons;
